import React from 'react';
import { NotificationsTable } from './comoponents/NotificationsTable';
import { getNotifRules, updateNotifRule } from '../../sp-firebase/notificationRulesFB';
import { useAccountStore } from '../../components/Stores/accountStore';
import { LoadingSpinnerOverlay } from '../../components/UI-Elements/LoadingSpinnerOverlay';
import { MaterialTrendButton } from '../Dashboard/MaterialTrendButton';
import { useMaterialsStore } from '../../components/Stores/MaterialsStore';
import { getMaterialsCardData } from '../Dashboard/dashboardUtils';
import { GENERAL_ID, useExposureStore } from '../../components/Stores/exposureDataStore';
import { useCurrencyRates } from '../../hooks/useCurrencyRates';
import { NotificationRule, notifSeverities } from '../../sp-types/notificationRule';
import { SpotLockUser } from '../../sp-types/userType';
import { getUsersByIds } from '../../sp-firebase/userFB';
import { OverlayDisplayDiv } from '../../components/UI-Elements/PopoverOverlays/OverlayDisplayDiv';
import { EditNotifRule } from './comoponents/EditNotifRule';
import { NotifFiltersBar } from './comoponents/NotifFiltersBar';

export const NotificationList: React.FC = () => {
  const { account, materialColorDictionary: colorsMap } = useAccountStore();
  const { materialsMap } = useMaterialsStore();
  const { convertionMap } = useCurrencyRates();
  const {
    currentSelectedMaterialId: materialId,
    netExposure,
    setCurrentSelectedMaterialId: setMaterialId,
  } = useExposureStore();

  const memoNetExposure = React.useMemo(() => netExposure, [netExposure, materialId]);
  const [notifRules, setNotifRules] = React.useState<any[]>();
  const [editRule, setEditRule] = React.useState<NotificationRule | undefined>();
  const [loading, setLoading] = React.useState<string[] | null>();
  const [filters, setFilters] = React.useState({
    account: account?.id || '',
    type: '',
    material: '',
    showActive: 'all',
  });
  const [searchText, setSearchText] = React.useState('');

  React.useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      account: account?.id || '',
      material: materialId === GENERAL_ID ? '' : materialId,
    }));
  }, [account, materialId]);

  const fetchRules = async () => {
    setLoading(['Loading rules...']);

    const rules = await getNotifRules(filters.account, filters.material, filters.type.toString(), filters.showActive);

    setNotifRules(rules);

    setLoading(null);
  };

  React.useEffect(() => {
    if (filters) {
      fetchRules();
    }
  }, [filters]);

  const userIds = React.useMemo(() => Object.keys(account?.users || {}).sort(), [account]);
  const [accountUsers, setAccountUsers] = React.useState<SpotLockUser[]>([]);

  React.useEffect(() => {
    if (userIds) {
      getUsersByIds(userIds).then((users) => {
        console.log('users', users);
        setAccountUsers(users || []);
      });
    }
  }, [userIds]);

  const updateRule = async (rule: NotificationRule) => {
    setLoading(['Saving rule']);

    await updateNotifRule(rule);

    await fetchRules();
  };

  const onEditRow = (row: NotificationRule) => {
    setEditRule(row);
  };

  return (
    <div className="flex flex-col flex-1 h-full  gap-3">
      <MaterialTrendButton
        buttons={getMaterialsCardData(
          materialsMap,
          colorsMap,
          convertionMap,
          account.materialsToAccount,
          memoNetExposure,
        )}
        currentMaterial={materialId}
        setCurrentMaterial={setMaterialId}
      />
      <div className="flex flex-col bg-white p-4">
        <NotifFiltersBar
          filters={filters}
          setFilters={setFilters}
          setSearchText={setSearchText}
          searchText={searchText}
          notificationTypes={notifSeverities.map((value) => ({ value, label: value }))}
        />
        <NotificationsTable
          data={notifRules?.filter((rule) => rule.name.toLowerCase().includes(searchText.toLowerCase())) || []}
          onChange={updateRule}
          users={accountUsers}
          onEditRow={onEditRow}
        />
        {editRule && (
          <OverlayDisplayDiv setDisplayOverlay={() => setEditRule(undefined)} hideClose>
            <EditNotifRule rule={editRule} updateRule={updateRule} close={() => setEditRule(undefined)} />
          </OverlayDisplayDiv>
        )}

        {loading && <LoadingSpinnerOverlay size={64}>{loading.join(' ')}</LoadingSpinnerOverlay>}
      </div>
    </div>
  );
};
